const mutations = {
    changeShowInterview(state, bool) {
        state.showInterview = bool;
    }
}

export default mutations;